import { SistRadnihMestaComponent } from './sist-radnih-mesta/sist-radnih-mesta.component';
import { KadComponent } from './kad.component';
import { NgModule } from '@angular/core';
import { KadBlModule } from './../kad.bl/kad.bl.module';
import { HomeComponent } from './home/home.component';
import { KadRoutingModule } from './kad-routing.module';
import { LookupsModule } from '../lookups/lookups.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BeneficiraniUpdateComponent } from './beneficirani/beneficirani-update.component';
import { BeneficiraniComponent } from './beneficirani/beneficirani.component';
import { BeneficiraniModalUpdateComponent } from './beneficirani/beneficirani-modal-update.component';
import { ModalContainerService, ModalService } from 'yt-ng-framework';
import { TranslateModule } from '@ngx-translate/core';
import { VerskiPraznikComponent } from './verski-praznik/verski-praznik.component';
import { VerskiPraznikUpdateComponent } from './verski-praznik/verski-praznik-update.component';
import { VerskiPraznikModalUpdateComponent } from './verski-praznik/verski-praznik-modal-update.component';
import { RazlogPrestankaRoComponent } from './razlog-prestanka-ro/razlog-prestanka-ro.component';
import { RazlogPrestankaRoUpdateComponent } from './razlog-prestanka-ro/razlog-prestanka-ro-update.component';
import { RazlogPrestankaRoModalUpdateComponent } from './razlog-prestanka-ro/razlog-prestanka-ro-modal-update.component';
import { OsnovZaGoComponent } from './osnov-za-go/osnov-za-go.component';
import { OsnovZaGoUpdateComponent } from './osnov-za-go/osnov-za-go-update.component';
import { OsnovZaGoModalUpdateComponent } from './osnov-za-go/osnov-za-go-modal-update.component';
import { OsnovZaPlacenoOdsustvoComponent } from './osnov-za-placeno-odsustvo/osnov-za-placeno-odsustvo.component';
import { OsnovZaPlacenoOdsustvoUpdateComponent } from './osnov-za-placeno-odsustvo/osnov-za-placeno-odsustvo-update.component';
import { OsnovZaPlacenoOdsustvoModalUpdateComponent } from './osnov-za-placeno-odsustvo/osnov-za-placeno-odsustvo-modal-update.component';
import { VeroispovestComponent } from './veroispovest/veroispovest.component';
import { VeroispovestUpdateComponent } from './veroispovest/veroispovest-update.component';
import { VeroispovestModalUpdateComponent } from './veroispovest/veroispovest-modal-update.component';
import { JezikComponent } from './jezik/jezik.component';
import { JezikUpdateComponent } from './jezik/jezik-update.component';
import { JezikModalUpdateComponent } from './jezik/jezik-modal-update.component';
import { RadnaKnjizicaComponent } from './radna-knjizica/radna-knjizica.component';
import { RadnaKnjizicaUpdateComponent } from './radna-knjizica/radna-knjizica-update.component';
import { RadnaKnjizicaModalUpdateComponent } from './radna-knjizica/radna-knjizica-modal-update.component';
import { SistRadnihMestaUpdateComponent } from './sist-radnih-mesta/sist-radnih-mesta-update.component';
import { AngazovanjeRoModalUpdateComponent } from './angazovanje-ro/angazovanje-ro-modal-update.component';
import { AngazovanjeRoUpdateComponent } from './angazovanje-ro/angazovanje-ro-update.component';
import { AngazovanjeRoResenjeModalUpdateComponent } from './angazovanje-ro/angazovanje-ro-resenje-modal-update.component';
import { AngazovanjeRoAnexModalUpdateComponent } from './angazovanje-ro/angazovanje-ro-anex-modal-update.component';
import { AngazovanjeRoResenjeUpdateComponent } from './angazovanje-ro/angazovanje-ro-resenje-update.component';
import { AngazovanjeRoAnexUpdateComponent } from './angazovanje-ro/angazovanje-ro-anex-update.component';
import { AngazovanjeRoComponent } from './angazovanje-ro/angazovanje-ro.component';
import { AngazovanjeRoResenjeComponent } from './angazovanje-ro/angazovanje-ro-resenje.component';
import { StatusRoComponent } from './status-ro/status-ro.component';
import { StatusRoModalUpdateComponent } from './status-ro/status-ro-modal-update.component';
import { StatusRoUpdateComponent } from './status-ro/status-ro-update.component';
import { RadnoVremeComponent } from './radno-vreme/radno-vreme.component';
import { RadnoVremeModalUpdateComponent } from './radno-vreme/radno-vreme-modal-update.component';
import { RadnoVremeUpdateComponent } from './radno-vreme/radno-vreme-update.component';
import { ResenjeZaPlacenoOdsustvoComponent } from './resenje-za-placeno-odsustvo/resenje-za-placeno-odsustvo.component';
import { ResenjeZaPlacenoOdsustvoUpdateComponent } from './resenje-za-placeno-odsustvo/resenje-za-placeno-odsustvo-update.component';
import { ResenjeZaPlacenoOdsustvoModalUpdateComponent } from './resenje-za-placeno-odsustvo/resenje-za-placeno-odsustvo-modal-update.component'; 
import { PravoNaGoUpdateComponent } from './pravo-na-go/pravo-na-go-update.component';
import { PravoNaGoTabsComponent } from './pravo-na-go/pravo-na-go-tabs.component';
import { PravoNaGoTabUpdateComponent } from './pravo-na-go/pravo-na-go-tab-update.component';
import { OsnovZaPravoNaGoUpdateContainer } from './pravo-na-go/osnov-za-pravo-na-go-update-container.component';
import { OsnovZaPravoNaGoInlineUpdateComponent } from './pravo-na-go/osnov-za-pravo-na-go-inline-update.component';
import { OsnovZaPravoNaGoUpdateComponent } from './pravo-na-go/osnov-za-pravo-na-go-update.component';
import { OsnovZaPravoNaGoModalUpdateComponent } from './pravo-na-go/osnov-za-pravo-na-go-modal-update.component';
import { TipStrucnogUsavrsavanjaComponent } from './tip-strucnog-usavrsavanja/tip-strucnog-usavrsavanja.component';
import { TipStrucnogUsavrsavanjaModalUpdateComponent} from  './tip-strucnog-usavrsavanja/tip-strucnog-usavrsavanja-modal-update.component';
import { TipStrucnogUsavrsavanjaUpdateComponent } from './tip-strucnog-usavrsavanja/tip-strucnog-usavrsavanja-update.component';
import { TipPotvrdeOStrucnomUsavrsavanjuComponent } from './tip-potvrde-o-strucnom-usavrsavanju/tip-potvrde-o-strucnom-usavrsavanju.component';
import { TipPotvrdeOStrucnomUsavrsavanjuUpdateComponent } from './tip-potvrde-o-strucnom-usavrsavanju/tip-potvrde-o-strucnom-usavrsavanju-update.component';
import { TipPotvrdeOStrucnomUsavrsavanjuModalUpdateComponent } from './tip-potvrde-o-strucnom-usavrsavanju/tip-potvrde-o-strucnom-usavrsavanju-modal-update.component';
import { StrucnoUsavrsavanjeUpdateComponent} from './strucno-usavrsavanje/strucno-usavrsavanje-update.component'
import { StrucnoUsavrsavanjeModalUpdateComponent } from './strucno-usavrsavanje/strucno-usavrsavanje-modal-update.component';
import { StrucnoUsavrsavanjeComponent} from './strucno-usavrsavanje/strucno-usavrsavanje.component';
import { ResenjeZaGoComponent } from './resenje-za-go/resenje-za-go.component';
import { ResenjeZaGoModalUpdateComponent } from './resenje-za-go/resenje-za-go-modal-update.component';
import { ResenjeZaGoUpdateComponent } from './resenje-za-go/resenje-za-go-update.component';
import { ResenjeZaGoTabUpdateComponent } from './resenje-za-go/resenje-za-go-tab-update.component';
import { ResenjeZaGoTabsComponent } from './resenje-za-go/resenje-za-go-tabs.component';
import { DeoZaResenjeZaGoUpdateContainer } from './resenje-za-go/deo-za-resenje-za-go-update-container.component';
import { DeoZaResenjeZaGoUpdateComponent } from './resenje-za-go/deo-za-resenje-za-go-update.component';
import { DeoZaResenjeZaGoInlineUpdateComponent } from './resenje-za-go/deo-za-resenje-za-go-inline-update.component';
import { DeoZaResenjeZaGoModalUpdateComponent } from './resenje-za-go/deo-za-resenje-za-go-modal-update.component';
import { PregledGoComponent } from './pregled-go/pregled-go.component';
import { FilterWithZaposlenComponent } from './_filters/filter-with-zaposlen.component';
import { SistRadnihMestaTabUpdateComponent } from './sist-radnih-mesta/sist-radnih-mesta-tab-update.component';
import { SistRadnihMestaStavkaUpdateComponent } from './sist-radnih-mesta/sist-radnih-mesta-stavka-update.component';
import { SistRadnihMestaTabsComponent} from './sist-radnih-mesta/sist-radnih-mesta-tabs.component';
import { SistRadnihMestaStavkaInlineUpdateComponent } from './sist-radnih-mesta/sist-radnih-mesta-stavka-inline-update.component';
import { SistRadnihMestaStavkaUpdateContainerComponent } from './sist-radnih-mesta/sist-radnih-mesta-stavka-update-container.component';
import { ZaposleniUpdateComponent } from './zaposleni/zaposleni-update.component';
import { ZaposleniTabUpdateComponent } from './zaposleni/zaposleni-tab-update.component';
import { ZaposleniTabsComponent } from './zaposleni/zaposleni-tabs.component';




@NgModule({
  imports: [
    KadRoutingModule,
    LookupsModule,
    NgbModule,
    TranslateModule
    , KadBlModule
    ],
  declarations: [HomeComponent, KadComponent
    , BeneficiraniUpdateComponent , BeneficiraniComponent, BeneficiraniModalUpdateComponent
    , VerskiPraznikComponent, VerskiPraznikUpdateComponent, VerskiPraznikModalUpdateComponent
    , RazlogPrestankaRoComponent, RazlogPrestankaRoUpdateComponent, RazlogPrestankaRoModalUpdateComponent
    , OsnovZaGoComponent, OsnovZaGoUpdateComponent, OsnovZaGoModalUpdateComponent
    , OsnovZaPlacenoOdsustvoComponent, OsnovZaPlacenoOdsustvoUpdateComponent, OsnovZaPlacenoOdsustvoModalUpdateComponent
    , VeroispovestComponent, VeroispovestUpdateComponent, VeroispovestModalUpdateComponent
    , JezikComponent, JezikUpdateComponent, JezikModalUpdateComponent
    , RadnaKnjizicaComponent, RadnaKnjizicaUpdateComponent, RadnaKnjizicaModalUpdateComponent
    , SistRadnihMestaComponent, SistRadnihMestaUpdateComponent
    , AngazovanjeRoModalUpdateComponent
    , AngazovanjeRoResenjeModalUpdateComponent
    , AngazovanjeRoAnexModalUpdateComponent
    , AngazovanjeRoUpdateComponent
    , AngazovanjeRoResenjeUpdateComponent
    , AngazovanjeRoAnexUpdateComponent
    , AngazovanjeRoComponent, AngazovanjeRoResenjeComponent
    , StatusRoComponent, StatusRoModalUpdateComponent, StatusRoUpdateComponent
    , RadnoVremeComponent, RadnoVremeModalUpdateComponent, RadnoVremeUpdateComponent 
    , ResenjeZaPlacenoOdsustvoComponent, ResenjeZaPlacenoOdsustvoModalUpdateComponent, ResenjeZaPlacenoOdsustvoUpdateComponent
    , PravoNaGoTabsComponent, PravoNaGoTabUpdateComponent, PravoNaGoUpdateComponent
    , OsnovZaPravoNaGoUpdateComponent, OsnovZaPravoNaGoInlineUpdateComponent, OsnovZaPravoNaGoUpdateContainer, OsnovZaPravoNaGoModalUpdateComponent
    , TipStrucnogUsavrsavanjaComponent, TipStrucnogUsavrsavanjaModalUpdateComponent, TipStrucnogUsavrsavanjaUpdateComponent
    , TipPotvrdeOStrucnomUsavrsavanjuComponent, TipPotvrdeOStrucnomUsavrsavanjuModalUpdateComponent, TipPotvrdeOStrucnomUsavrsavanjuUpdateComponent
    , StrucnoUsavrsavanjeComponent, StrucnoUsavrsavanjeUpdateComponent, StrucnoUsavrsavanjeModalUpdateComponent
    , ResenjeZaGoComponent, ResenjeZaGoModalUpdateComponent, ResenjeZaGoUpdateComponent
    , ResenjeZaGoTabUpdateComponent, ResenjeZaGoTabsComponent
    , DeoZaResenjeZaGoUpdateComponent, DeoZaResenjeZaGoUpdateContainer
    , DeoZaResenjeZaGoInlineUpdateComponent
    , DeoZaResenjeZaGoModalUpdateComponent
    , PregledGoComponent
    , FilterWithZaposlenComponent
    , SistRadnihMestaTabUpdateComponent
    , SistRadnihMestaStavkaUpdateComponent
    , SistRadnihMestaTabsComponent 
    , SistRadnihMestaStavkaInlineUpdateComponent
    , SistRadnihMestaStavkaUpdateContainerComponent, ZaposleniUpdateComponent, 
    ZaposleniTabsComponent, ZaposleniTabUpdateComponent
    

    
  ]
    , exports: [ 
      BeneficiraniUpdateComponent
      , VerskiPraznikUpdateComponent
      , RazlogPrestankaRoComponent, RazlogPrestankaRoUpdateComponent
      , OsnovZaGoComponent, OsnovZaGoUpdateComponent
      , OsnovZaPlacenoOdsustvoComponent, OsnovZaPlacenoOdsustvoUpdateComponent
      , VeroispovestComponent, VeroispovestUpdateComponent
      , JezikComponent, JezikUpdateComponent
      , AngazovanjeRoModalUpdateComponent
      , AngazovanjeRoResenjeModalUpdateComponent
      , AngazovanjeRoAnexModalUpdateComponent
      , AngazovanjeRoUpdateComponent
      , AngazovanjeRoResenjeUpdateComponent
      , AngazovanjeRoAnexUpdateComponent
      , AngazovanjeRoComponent, AngazovanjeRoResenjeComponent
      , StatusRoComponent, StatusRoModalUpdateComponent, StatusRoUpdateComponent
      , RadnoVremeComponent, RadnoVremeModalUpdateComponent, RadnoVremeUpdateComponent 
      , ResenjeZaPlacenoOdsustvoComponent, ResenjeZaPlacenoOdsustvoUpdateComponent
      , PravoNaGoTabUpdateComponent
      , OsnovZaPravoNaGoUpdateComponent, OsnovZaPravoNaGoModalUpdateComponent     
      , ResenjeZaGoTabsComponent, ResenjeZaGoUpdateComponent
      , DeoZaResenjeZaGoUpdateComponent, DeoZaResenjeZaGoUpdateContainer
      , DeoZaResenjeZaGoModalUpdateComponent
      , TipStrucnogUsavrsavanjaModalUpdateComponent
      , SistRadnihMestaTabsComponent
      , SistRadnihMestaStavkaUpdateComponent
      , SistRadnihMestaStavkaUpdateContainerComponent
      
    ]    
    // ,entryComponents: [
    //    RazlogPrestankaRoModalUpdateComponent
    //   , OsnovZaGoModalUpdateComponent
    //   , OsnovZaPlacenoOdsustvoModalUpdateComponent
    //   , VeroispovestModalUpdateComponent
    //   , JezikModalUpdateComponent
    //   , RadnaKnjizicaModalUpdateComponent
    //   , ResenjeZaPlacenoOdsustvoModalUpdateComponent
    //   , OsnovZaPravoNaGoModalUpdateComponent
    //   , PravoNaGoTabsComponent, PravoNaGoUpdateComponent
    //   , DeoZaResenjeZaGoModalUpdateComponent
    //   , AngazovanjeRoModalUpdateComponent
    //   , TipStrucnogUsavrsavanjaModalUpdateComponent
    //   , FilterWithZaposlenComponent
    //   , SistRadnihMestaTabsComponent
    //   , TipStrucnogUsavrsavanjaModalUpdateComponent
    //   , TipPotvrdeOStrucnomUsavrsavanjuModalUpdateComponent
    //   , StatusRoModalUpdateComponent
    //   , VerskiPraznikModalUpdateComponent
    // ],
    
    ,providers: [
      ModalContainerService,
      ModalService
    ]
})
export class KadModule { }
